import "../../../Assets/Style/Confirm.scss";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { generateTransactionID } from "../../../Library/Utilities";
import { useDispatch, useSelector } from "react-redux";
import {
  BookInternationalShipment,
  ClearRecord,
} from "../../../store/InternationalAction";

const ConfirmSection = ({ setTab }) => {
  const dispatch = useDispatch();

  const user_id = localStorage.getItem("user_id");
  const user_ses_id = localStorage.getItem("session_id");
  const company_id = localStorage.getItem("company_id");
  const transaction_id = generateTransactionID(15);
  const {
    isLoading,
    isBook,
    Sender,
    Receiver,
    Package,
    PaymentOption,
    PriceDetails
  } = useSelector((state) => state.International);

  const HomeHandle = () => {
    dispatch(ClearRecord());
    setTab(0);
  };

  // This function gets the description of all items in the package
  // and concatenate into a string
  // function getDescriptionString(array) {
  //   return array.map((obj) => obj.description).join(", ");
  // }

  const BookShipment = () => {
    const data = {
      booking: {
        rate_id: PriceDetails?.rate_id,
        partner_rate_id: PriceDetails?.partner_rate_id,
        carrier_id: PriceDetails?.carrier_id,
        processing_station_id: "1",
        schedule_date: "Now",
        currency: "NGN",
        payment_method: PaymentOption,
        insurance: {
          request_insurance: "No",
          insurance_type: "Standard",
          insurance_fee: 0,
        },
        pickup: {
          request_pickup: "No",
          pickup_type_id: "Standard",
          pickup_fee: 0,
        },
        services: [],
        fees: {
          standard_fee: PriceDetails?.selling_price,
          services_fee: 0,
          extras_fee: 0,
          shipping_fee: PriceDetails?.selling_price,
        },
      },
      sender: {
        first_name: Sender.first_name,
        last_name: Sender.last_name,
        address_1: Sender.address_one,
        address_2: Sender.address_two,
        city: Sender.city,
        state: Sender.state,
        country: Sender.country,
        postcode: Sender.post_code,
        email: Sender.sender_email,
        phone_no: Sender.mobile,
      },
      receiver: {
        first_name: Receiver.first_name,
        last_name: Receiver.last_name,
        address_1: Receiver.address_one,
        address_2: Receiver.address_two,
        city: Receiver.city,
        state: Receiver.state,
        country: Receiver.country,
        postcode: Receiver.post_code,
        email: Receiver.recipient_email,
        phone_no: Receiver.mobile,
      },
      package: {
        package_type: "Parcel",
        package_image_url: "",
        packages: Package
      },
      user_id: user_id,
      transaction_id: transaction_id,
      company_id: company_id,
      user_ses_id: user_ses_id,
      shipment_type: "International",
      flutterwave_amount: PriceDetails?.selling_price,
      transaction_reference_no: ""
    };
    dispatch(BookInternationalShipment(data));
  };

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  let packageValue = Package?.reduce((accumulator, currentObject) => {
    return accumulator + parseFloat(currentObject?.package_value);
  }, 0);

  let packageWeight = Package?.reduce((accumulator, currentObject) => {
    return accumulator + parseFloat(currentObject?.package_weight);
  }, 0);

  let allPackageItems = [];

  // Outer loop to iterate through the varObj array
  for (let i = 0; i < Package.length; i++) {
    // Inner loop to iterate through the sports array for each object
    for (let j = 0; j < Package[i].package_items.length; j++) {
      // Push each sport object into the allSports array
      allPackageItems.push(Package[i].package_items[j]);
    }
  }

  return (
    <>
      {!isBook && (
        <div data-aos="fade-zoom-in" className="Confirm">
          <h2>SUMMARY</h2>
          <div className="Box">
            <p>SENDER DETAILS</p>
            <div className="Right">
              <h4>
                {Sender.first_name} {Sender.last_name}
              </h4>
              <h6>{Sender.address_one}</h6>
            </div>
          </div>
          <div className="Box">
            <p>RECEIVER DETAILS</p>
            <div className="Right">
              <h4>
                {Receiver.first_name} {Receiver.last_name}
              </h4>
              <h6>{Receiver.address_one}</h6>
            </div>
          </div>
          <div className="Box">
            <p>DECLARED WEIGHT</p>
            <div className="Right">
              <h4>{packageWeight}KG</h4>
              {/* <h6>1CM X 1CM X 1CM</h6> */}
            </div>
          </div>
          <div className="Box">
            <p>PACKAGE</p>
            <div className="Right">
              {allPackageItems.map((item, index) => (
                <h6 key={index}>{item.description} </h6>
              ))}
            </div>
          </div>
          <div className="Box">
            <p>PACKAGE VALUE</p>
            <div className="Right">
              <h4>
                {allPackageItems[0]?.currency === "USD" ? "$" : "₦"}
                {parseFloat(packageValue).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                })}
              </h4>
            </div>
          </div>
          <div className="Box">
            <p>PAYMENT MENTHOD</p>
            <div className="Right">
              <h4>{PaymentOption}</h4>
            </div>
          </div>
          <div className="Bottom_Box">
            <div className="Left">
              By continuing, I represent that the declaration above is a proper
              and accurate description of the contents of my package.
            </div>
            <div className="Right">
              <h3>NGN {parseFloat(PriceDetails.amount).toLocaleString("en-US")}</h3>
              <h5>Inc. VAT</h5>
            </div>
          </div>
          <button onClick={BookShipment}>
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "BOOK SHIPMENT"
            )}
          </button>
          <button
            className="PrevBtn"
            style={{ backgroundColor: "#225AA4" }}
            onClick={(e) => {
              e.preventDefault();
              setTab(3);
            }}
            type="button"
          >
            PREVIOUS
          </button>
        </div>
      )}
      {isBook && (
        <div data-aos="fade-zoom-in" className="Successfull">
          <h4>Shipment as been book Successfully</h4>
          <p>You can go ahead</p>
          <p>to track your delivery</p>
          <div onClick={HomeHandle} className="Btn">
            Back
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmSection;
